import { useEffect } from 'react';

// Lane.Chat support widget for signed-in console users. The app key is public (meant for browser code).
// identify() data is set from the browser and can be altered by the visitor: agents must not treat it as verified.
const APP_KEY = 'app_4918f388889186a7552f39b50397185e';
const SRC = 'https://cdn.lane.chat/js/widget.js';

let loading = null;
function loadWidget() {
    if (window.laneChat) return Promise.resolve(window.laneChat);
    if (loading) return loading;
    window.laneChatManualInit = true;
    window.laneChatAppId = APP_KEY;
    loading = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = SRC;
        s.async = true;
        s.onload = () => resolve(window.laneChat);
        s.onerror = () => { loading = null; reject(new Error('lane.chat load failed')); };
        document.body.appendChild(s);
    });
    return loading;
}

export default function SupportChat({ user }) {
    const uid = user?.id;
    useEffect(() => {
        if (!uid) return undefined;
        let cancelled = false;
        loadWidget().then((lc) => {
            if (cancelled || !lc) return;
            lc.init();
            lc.identify({
                email: user.email || undefined,
                name: user.username || user.email || undefined,
                user_id: String(uid),
                company: user.company || undefined,
            });
        }).catch(() => {});
        return () => {
            cancelled = true;
            // Unmount on sign-out / account switch so the next user does not land in this chat panel.
            try { window.laneChat?.destroy(); } catch (e) { /* ignore */ }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid]);
    return null;
}
